import { runImpactCalculateCo2ForProject } from '@/domain/impact-calculate/actions/run-impact-calculate-co2-for-project.action';
import { SnackbarGateway } from '@/domain/snackbar/gateways/snackbar.gateway';
import { createAppAsyncThunk } from '@/domain/store.thunk';
import { translate } from '@/ui/i18n';

import { ExternalInvitation } from '../entities/external-invitation.entity';
import { getExternalInvitations } from './get-external-invitations.action';

type Params = {
  invitation: ExternalInvitation;
  isValidated: boolean;
};

export const changeInvitationIsValidated = createAppAsyncThunk(
  'externalInvitation/changeInvitationIsValidated',
  async (
    { invitation, isValidated }: Params,
    { extra: { externalInvitationGateway, snackbarGateway }, dispatch },
  ) => {
    try {
      await externalInvitationGateway.changeInvitationIsValidated(
        invitation.id,
        isValidated,
      );
      showSnackbarSuccess(snackbarGateway);
      const projectId = invitation.projectId;
      dispatch(getExternalInvitations({ projectId }));
      dispatch(runImpactCalculateCo2ForProject({ projectId }));
    } catch (error) {
      showSnackbarError(snackbarGateway);
      throw error;
    }
  },
);

function showSnackbarSuccess(snackbarGateway: SnackbarGateway) {
  snackbarGateway.success(
    translate('ChangeInvitationIsValidated.Message.success'),
  );
}

function showSnackbarError(snackbarGateway: SnackbarGateway) {
  snackbarGateway.error(translate('ChangeInvitationIsValidated.Message.error'));
}
